// src/pages/Privacy.js
import React from 'react';

export default function Privacy() {
  return (
    <div className="page">
    <div className="row justify-content-center">
      <div className="col-md-10 col-lg-8">
        <div className="card shadow-sm">
          <div className="card-body">
            <h1 className="h3 mb-3">Privacy Policy</h1>
            <p className="text-muted mb-4">Effective Date: 5/1/2026</p>

            <p>
              Aullan LLC (“we”, “our”, or “us”) is committed to protecting the privacy
              and security of personal and medical information. This Privacy
              Policy explains how the Aullan Bro mobile application (“App”) collects,
              uses, stores, and protects information when used by doctors and
              clinics.
            </p>

            <p>
              The App is intended exclusively for doctors and clinics operating
              in Iraq. Patients do not create accounts or log in to the App.
            </p>

            <h2 className="h5 mt-4">1. Who Can Use the App</h2>
            <p>
              Aullan is designed only for doctors and clinics. Anyone may
              register, but the App is intended for use by medical professionals.
              Doctors are responsible for all data entered and managed within
              their account.
            </p>

            <h2 className="h5 mt-4">2. Information We Collect</h2>

            <h3 className="h6 mt-3">2.1 Doctor Information</h3>
            <ul>
              <li>Name</li>
              <li>Phone number</li>
              <li>Email address</li>
              <li>Medical specialty</li>
              <li>Clinic location (optional)</li>
              <li>Brief professional description (optional)</li>
              <li>Opening hours (optional)</li>
              <li>License number (optional)</li>
            </ul>

            <h3 className="h6 mt-3">2.2 Patient Information</h3>
            <p>
              Doctors may choose to store patient information in the App,
              including but not limited to:
            </p>
            <ul>
              <li>Name</li>
              <li>Phone number</li>
              <li>Age and gender</li>
              <li>Medical history</li>
              <li>Diagnoses</li>
              <li>Prescriptions</li>
              <li>Clinical notes</li>
              <li>Attachments such as reports or images</li>
            </ul>
            <p>
              Patient data is entered, accessed, and controlled solely by the
              logged-in doctor.
            </p>

            <h2 className="h5 mt-4">3. How We Use Information</h2>
            <p>Information is used only to:</p>
            <ul>
              <li>Provide electronic health record functionality</li>
              <li>Manage appointments and patient records</li>
              <li>Enable optional online booking features</li>
              <li>Send appointment reminders or doctor-initiated WhatsApp messages</li>
              <li>Maintain and improve App security and performance</li>
            </ul>
            <p>
              We do not use personal or patient data for advertising or marketing
              purposes.
            </p>

            <h2 className="h5 mt-4">4. WhatsApp Messaging</h2>
            <p>
              The App provides an optional feature allowing doctors to send
              instructions to patients via WhatsApp.
            </p>
            <ul>
              <li>Messages are sent only when initiated by the doctor</li>
              <li>Patient phone numbers are provided by the doctor</li>
              <li>Message content is created and approved by the doctor</li>
              <li>Aullan does not read WhatsApp message content</li>
            </ul>
            <p>
              Use of WhatsApp is subject to WhatsApp’s own terms and privacy
              policy.
            </p>

            <h2 className="h5 mt-4">5. Online Booking & Shareable Link</h2>
            <p>
              Each doctor is provided with a shareable public link that contains
              basic professional information such as the doctor’s name, phone
              number, and public clinic details. This link is always available to
              the doctor.
            </p>
            <p>
              Online appointment booking through this link is optional and fully
              controlled by the doctor:
            </p>
            <ul>
              <li>
                If online booking is enabled, patients may request appointments
                based on the doctor’s available calendar.
              </li>
              <li>
                If online booking is disabled, the link will display information
                only and will not allow appointment booking.
              </li>
            </ul>
            <p>
              Patients do not create accounts, and only information explicitly
              made public by the doctor is visible.
            </p>

            <h2 className="h5 mt-4">6. Data Storage & Security</h2>
            <ul>
              <li>Data is stored on Aullan’s secure servers</li>
              <li>All data transmission uses HTTPS encryption</li>
              <li>
                Access to data is restricted to the authenticated doctor only
              </li>
            </ul>

            <h2 className="h5 mt-4">7. Data Sharing</h2>
            <p>
              We do not sell, rent, or share personal or patient data with third
              parties, except where required by law or necessary to provide
              features explicitly requested by the doctor.
            </p>

            <h2 className="h5 mt-4">8. Account & Data Deletion</h2>
            <p>
              Doctor-provided information may be reviewed manually, including contact, before access to certain features (such as creating patient records) is enabled.
            </p>
            <p>
              Doctors can delete their account directly from within the App.
              When an account is deleted:
            </p>
            <ul>
              <li>The doctor’s account information is permanently removed</li>
              <li>All associated patient data is permanently deleted</li>
            </ul>

            <h2 className="h5 mt-4">9. Data Retention</h2>
            <p>
              Data is retained only while the doctor’s account remains active.
              Once an account is deleted, all data is removed as described above.
            </p>

            <h2 className="h5 mt-4">10. Children’s Privacy</h2>
            <p>
              The App is not intended for children and does not knowingly collect
              personal data directly from children.
            </p>

            <h2 className="h5 mt-4">11. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. Any changes
              will be posted on this page with an updated effective date.
            </p>

            <h2 className="h5 mt-4">12. Contact Us</h2>
            <p>
              If you have questions or requests regarding privacy or data
              deletion, please contact us:
            </p>
            <p className="mb-0">
              <strong>Email:</strong> support@aullan.com<br />
              <strong>Company:</strong> Aullan LLC
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  );
}
